/**
 * Deploy-time build ID injected by Vite at build time. Used to version
 * static asset URLs so a new deploy invalidates browser/CDN caches
 * immediately — no waiting for TTL, no manual `?v=NN` bumps.
 *
 * Hashed build outputs (JS/CSS chunks) and CDN assets under
 * /__l5e/assets-v1/* are already content-versioned by hash/UUID and do
 * NOT need this helper.
 */
export const BUILD_ID: string =
  (import.meta.env.VITE_BUILD_ID as string | undefined) ?? "dev";

/**
 * Append `?v=<BUILD_ID>` to a static asset URL from /public. Preserves
 * an existing query string.
 */
export function versioned(path: string): string {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}v=${BUILD_ID}`;
}
